import type { Settlement } from '../engine/map/settlement';
import { getGameConfig } from '../config/gameConfig';
import { runIndependentProductionTick } from './genericProduction';

export function runMasonryTick(settlement: Settlement): boolean {
    const config = getGameConfig();
    return runIndependentProductionTick(
        settlement,
        'masonry',
        settlement.jobs.masons,
        settlement.production.masonry.progress,
        config.production.masonry.ticksPerBrick,
    );
}
